import { cn } from '@/lib/tailwind';
import type { UiGradientOverlayVariant } from './UiGradientOverlay.types';

export const uiGradientOverlayStyles: Record<UiGradientOverlayVariant, string> = {
    top: cn('top-0 inset-x-0 h-1/3', '[background:linear-gradient(180deg,rgba(35,35,35,0.56)_0%,transparent_100%)]'),
    bottom: cn(
        'bottom-0 inset-x-0 h-1/3',
        '[background:linear-gradient(0deg,var(--body-color-bg)_0%,transparent_100%)]',
    ),
    left: cn('left-0 inset-y-0 w-25', '[background:linear-gradient(90deg,var(--body-color-bg)_0%,transparent_100%)]'),
    right: cn('right-0 inset-y-0 w-25', '[background:linear-gradient(90deg,transparent_0%,var(--body-color-bg)_100%)]'),
} as const;
